import { Navigate, useLocation } from 'react-router-dom'

/** The Voice Agent dashboard moved to Agents → Voice. Links keep their params (`?drawer=`, `?tab=`). */
export default function AIAgentVoiceRedirect() {
  const { search } = useLocation()
  return <Navigate to={`/agents/voice${search}`} replace />
}
